import { apiTypes } from 'ui/api'

export const manifestProviders: apiTypes.ApiProviderName[] = [
	'UPS',
	'Speedee',
	'Fedex',
	'Purolator',
	'Canada_Post',
]
